import AddressField from 'components/StraightThroughAddressComp/CustomInputs/AddressField/AddressField';
import DateField from 'components/StraightThroughHouseholdComp/CustomInputs/DateField/DateField';
import { RadioButtonField } from 'components/StraightThroughHouseholdComp/CustomInputs/RadioButtonField/RadioButtonField';
import SelectDropdown from 'components/StraightThroughHouseholdComp/CustomInputs/SelectDropdown/SelectDropdown';
import dlStatus from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/DLStatus';
import gender from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/Gender';
import insuranceType from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/InsuranceType';
import mStatus from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/MStatus';
import relationship from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/Relationship';
import states from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/States';
import TextField from 'components/StraightThroughHouseholdComp/CustomInputs/TextField/TextField';
import { useDriverHHM } from 'components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext';
import HelpfulDocumentsNJ from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsNJ/HelpfulDocumentsNJ';
import HelpfulDocumentsPA from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsPA/HelpfulDocumentsPA';
import { useState } from 'react';

const AddDriverForm = ({ context }) => {
  const driverContext = useDriverHHM();
  const [requestedEffDate, setRequestedEffDate] = useState();

  const blIsMichigan = context?.userData?.state === 'Michigan';
  return (
    <>
      <h5 className='text-primary text-center fw-bold my-3'>ADD DRIVER</h5>

      <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>
      {context?.addressChangeClass?.requestType !== "Address Change" &&
        <DateField
          label="Requested Effective Date*"
          dateSubmit={driverContext?.driverHHM?.requestedEffDate ? driverContext?.driverHHM?.requestedEffDate : requestedEffDate}
          setDateSubmit={setRequestedEffDate}
          storeValue={driverContext?.driverHHMCallback}
          nameValue="requestedEffDate"
          infoKey="requestedEffDate"
        />
      }

      {/* Full Name */}
      <TextField
        label={"Full Name*"}
        nameField={true}
        infoKey={"userInfo"}
        nameValues={{ firstName: driverContext?.driverHHM?.userInfo?.firstName, middleInitial: driverContext?.driverHHM?.userInfo?.middleInitial, lastName: driverContext?.driverHHM?.userInfo?.lastName }}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Date of Birth */}
      <SelectDropdown
        label={"Date of Birth*"}
        infoKey={"userInfo"}
        dobField={true}
        setCallback={driverContext?.driverHHMCallback}
        dobValues={{ dobMonth: driverContext?.driverHHM?.userInfo?.dobMonth, dobDay: driverContext?.driverHHM?.userInfo?.dobDay, dobYear: driverContext?.driverHHM?.userInfo?.dobYear }}
      />

      {/* Marital Status */}
      <SelectDropdown
        label={"Marital Status*"}
        infoKey={"userInfo"}
        dropdown={mStatus}
        name={"maritalStatus"}
        value={driverContext?.driverHHM?.userInfo?.maritalStatus}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Gender */}
      <SelectDropdown
        label={"Gender*"}
        infoKey={"userInfo"}
        name={"gender"}
        value={driverContext?.driverHHM?.userInfo?.gender}
        dropdown={gender(context?.userData?.state)}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Current License Status */}
      <SelectDropdown
        label={"What is the current status of this driver's license?*"}
        name={"licenseStatus"}
        infoKey='driverInfo'
        value={driverContext?.driverHHM?.driverInfo?.licenseStatus}
        dropdown={dlStatus(context?.userData?.state)}
        setCallback={driverContext?.driverHHMCallback}
      />

      {driverContext?.driverHHM?.driverInfo?.licenseStatus &&
        <>
          {/* Age Licensed */}
          <TextField
            label={"Age Licensed*"}
            name={"licenseAge"}
            infoKey='driverInfo'
            value={driverContext?.driverHHM?.driverInfo?.licenseAge}
            setCallback={driverContext?.driverHHMCallback}
          />

          {driverContext?.driverHHM?.driverInfo?.licenseStatus !== "Valid Foreign License" &&
            <>
              {/* License State */}
              <SelectDropdown
                label={context?.userData?.state == "New Jersey" ? "In what state is this driver licensed?*" : "License State*"}
                name={"licenseState"}
                infoKey='driverInfo'
                value={driverContext?.driverHHM?.driverInfo?.licenseState}
                dropdown={states}
                setCallback={driverContext?.driverHHMCallback}
              />
            </>
          }

          {["New Jersey", "Pennsylvania"].includes(context?.userData?.state) && driverContext?.driverHHM?.driverInfo?.licenseStatus == "Valid Foreign License" &&
            <>
              {/* License Country */}
              < TextField
                label={"In what country is this driver licensed?*"}
                name={"licenseCountry"}
                infoKey='driverInfo'
                value={driverContext?.driverHHM?.driverInfo?.licenseCountry}
                setCallback={driverContext?.driverHHMCallback}
              />
            </>
          }

          {/* License Number */}
          <TextField
            label={"License Number*"}
            name={"licenseNumber"}
            infoKey='driverInfo'
            value={driverContext?.driverHHM?.driverInfo?.licenseNumber}
            setCallback={driverContext?.driverHHMCallback}
          />
        </>
      }

      {/* Relationship */}
      <SelectDropdown
        label={`Relationship to policyholder (${context?.userData?.firstName})*`}
        name={"relationshipToPolicyholder"}
        infoKey='userInfo'
        value={driverContext?.driverHHM?.userInfo?.relationshipToPolicyholder}
        dropdown={relationship}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Type of Health Insurance (Michigan Only) */}
      {context?.userData?.state === 'Michigan' &&
        !(["", "Other Non-relative"].includes(driverContext?.driverHHM?.userInfo?.relationshipToPolicyholder)) &&
        [4, 5, 6].includes(context?.userData?.pipOption) &&
        <>
          {/* Health Insurance */}
          <RadioButtonField
            question={"Does this driver have health insurance?*"}
            name={"hasInsurance"}
            infoKey='driverInfo'
            value={driverContext?.driverHHM?.driverInfo?.hasInsurance ? driverContext?.driverHHM?.driverInfo?.hasInsurance : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {/* Type of Health Insurance */}
          {[4, 5, 6].includes(context?.userData?.pipOption) &&
            driverContext?.driverHHM?.driverInfo?.hasInsurance === "1" &&
            <SelectDropdown
              label={"Please confirm what type of health insurance this driver has.*"}
              name={"insuranceType"}
              infoKey='driverInfo'
              value={driverContext?.driverHHM?.driverInfo?.insuranceType}
              dropdown={insuranceType}
              setCallback={driverContext?.driverHHMCallback}
            />
          }
        </>
      }

      {/* Same Household */}
      <RadioButtonField
        question={"Resides in same household?*"}
        name={"sameHousehold"}
        infoKey='addressInfo'
        value={driverContext?.driverHHM?.addressInfo?.sameHousehold || ""}
        setCallback={driverContext?.driverHHMCallback}
      />

      {driverContext?.driverHHM?.addressInfo?.sameHousehold === "0" &&
        <>
          <p className='col-12 text-primary fw-bold field'>
            What is this driver's address?*
          </p>
          {/* Address and Apartment Number Fields */}
          <AddressField
            label1="driverStreetName"
            name1="driverStreetName"
            infoKey="addressInfo"
            value1={driverContext?.driverHHM?.addressInfo?.driverStreetName}
            placeholder1="Home Address *"
            label2="driverAptNumber"
            name2="driverAptNumber"
            value2={driverContext?.driverHHM?.addressInfo?.driverAptNumber}
            placeholder2="Apt #"
            setCallback={driverContext?.driverHHMCallback}
            householdAddress={true}
          />

          {/* City and Zip Fields */}
          <AddressField
            label1="driverCity"
            name1="driverCity"
            infoKey="addressInfo"
            value1={driverContext?.driverHHM?.addressInfo?.driverCity}
            placeholder1="City *"
            label2="driverZip"
            name2="driverZip"
            value2={driverContext?.driverHHM?.addressInfo?.driverZip}
            placeholder2="Zip *"
            setCallback={driverContext?.driverHHMCallback}
            householdAddress={true}
          />
        </>
      }

      {/* Reside in state */}
      <RadioButtonField
        question={`Does this person currently reside in ${context?.userData?.state}*?`}
        name={"resideInState"}
        infoKey='addressInfo'
        value={driverContext?.driverHHM?.addressInfo?.resideInState ? driverContext?.driverHHM?.addressInfo?.resideInState : ""}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Occupation */}
      <TextField
        label={"What is this person's occupation?*"}
        infoKey='userInfo'
        name={"occupation"}
        value={driverContext?.driverHHM?.userInfo?.occupation}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Enrolled in college/university */}
      {driverContext?.driverHHM?.userInfo?.dobMonth && driverContext?.driverHHM?.userInfo?.dobDay && driverContext?.driverHHM?.userInfo?.dobYear && driverContext?.calculateAge(driverContext?.driverHHM?.userInfo?.dobMonth, driverContext?.driverHHM?.userInfo?.dobDay, driverContext?.driverHHM?.userInfo?.dobYear) <= 24 &&
        <>
          <RadioButtonField
            question={"Driver enrolled in college/university?*"}
            infoKey='schoolInfo'
            name={"enrolledInCollege"}
            value={driverContext?.driverHHM?.schoolInfo?.enrolledInCollege ? driverContext?.driverHHM?.schoolInfo?.enrolledInCollege : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {driverContext?.driverHHM?.schoolInfo?.enrolledInCollege == "1" &&
            <>
              {/* School over 100 miles */}
              <RadioButtonField
                question={"Is school over 100 miles away from the policy address?*"}
                infoKey='schoolInfo'
                name={"school100Miles"}
                value={driverContext?.driverHHM?.schoolInfo?.school100Miles ? driverContext?.driverHHM?.schoolInfo?.school100Miles : ""}
                setCallback={driverContext?.driverHHMCallback}
              />

              {/* School Name */}
              <TextField
                label={"School Name*"}
                infoKey='schoolInfo'
                name={"schoolName"}
                value={driverContext?.driverHHM?.schoolInfo?.schoolName}
                setCallback={driverContext?.driverHHMCallback}
              />

              {/* School City */}
              <TextField
                label={"School City*"}
                infoKey='schoolInfo'
                name={"schoolCity"}
                value={driverContext?.driverHHM?.schoolInfo?.schoolCity}
                setCallback={driverContext?.driverHHMCallback}
              />

              {/* School State */}
              <TextField
                label={"School State*"}
                infoKey='schoolInfo'
                name={"schoolState"}
                value={driverContext?.driverHHM?.schoolInfo?.schoolState}
                setCallback={driverContext?.driverHHMCallback}
              />
            </>
          }
        </>
      }

      <hr />

      {/* Convicted (Michigan Only) */}
      {context?.userData?.state == 'Michigan' && (
        <RadioButtonField
          question={`Has this person been convicted in the past 5 years of fraud or intent to defraud involving an insurance claim or an application for insurance; 
            Or has this person successfully been denied in the past 5 years, payment of a claim over $1,000.00 under an auto insurance policy, if there was evidence 
            or fraud or the intent to defraud involving an insurance claim or application?*`}
          uw={true}
          name={"convicted"}
          infoKey='violationInfo'
          value={driverContext?.driverHHM?.violationInfo?.convicted ? driverContext?.driverHHM?.violationInfo?.convicted : ""}
          setCallback={driverContext?.driverHHMCallback}
        />
      )}

      {/* Military */}
      <RadioButtonField
        question={"Is the driver a member of any branch of military?*"}
        uw={true}
        name={"militaryMember"}
        infoKey='userInfo'
        value={driverContext?.driverHHM?.userInfo?.militaryMember ? driverContext?.driverHHM?.userInfo?.militaryMember : ""}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* Disorders */}
      <RadioButtonField
        question={"Does the driver have a disorder or condition that may impair their ability to safely operate a motor vehicle, including but not limited to Narcolepsy, Syncope, Blindness, or Seizures?*"}
        uw={true}
        name={"disorders"}
        infoKey='disabilityInfo'
        value={driverContext?.driverHHM?.disabilityInfo?.disorders ? driverContext?.driverHHM?.disabilityInfo?.disorders : ""}
        setCallback={driverContext?.driverHHMCallback}
      />

      {/* ------------------------------------------------------------- UW Questions ------------------------------------------------------------- */}
      {/* Michigan */}
      {context?.userData?.state == 'Michigan' && (
        <div style={{ marginRight: '12px' }}>
          <p className='text-primary fw-bold field'>
            Has the driver been convicted of, or has been subject to an order of disposition of the family division of circuit court for a violation
            of any of the following, within the last 3 years:
          </p>

          <div className='ms-3'>
            {/* Moving violation resulting in death/serious impairment */}
            <RadioButtonField
              question={
                'a. Moving violation causing death or serious impairment of body function; or any other Michigan law for which a violation constitutes a felony resulting from the operation of a motor vehicle.*'
              }
              uw={true}
              name={'seriousMovingViolations'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.seriousMovingViolations ? driverContext?.driverHHM?.violationInfo?.seriousMovingViolations : ""}
              setCallback={driverContext?.driverHHMCallback}
            />

            {/* Under influence */}
            <RadioButtonField
              question={'b. Operation of motor vehicle while under influence.*'}
              uw={true}
              name={'underInfluence'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.underInfluence ? driverContext?.driverHHM?.violationInfo?.underInfluence : ""}
              setCallback={driverContext?.driverHHMCallback}
            />

            {/* Failure to stop resulting in serious impairment */}
            <RadioButtonField
              question={'c. Failure to stop when involved in an accident that results in serious impairment of a body function or death.*'}
              uw={true}
              name={'impairment'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.impairment ? driverContext?.driverHHM?.violationInfo?.impairment : ""}
              setCallback={driverContext?.driverHHMCallback}
            />

            {/* Failure to stop resulting in injury */}
            <RadioButtonField
              question={'d. Failure to stop when involved in an accident that results in injury to any individual.*'}
              uw={true}
              name={'ftsInjury'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.ftsInjury ? driverContext?.driverHHM?.violationInfo?.ftsInjury : ""}
              setCallback={driverContext?.driverHHMCallback}
            />

            {/* Failure to stop resulting in vehicle damage */}
            <RadioButtonField
              question={
                'e. Failure to stop when involved in an accident that results in damage to a vehicle operated by or attended by any individual.*'
              }
              uw={true}
              name={'vehicleDamage'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.vehicleDamage ? driverContext?.driverHHM?.violationInfo?.vehicleDamage : ""}
              setCallback={driverContext?.driverHHMCallback}
            />

            {/* Failure to provide required info */}
            <RadioButtonField
              question={'f. Failure to provide required information or to provide reasonable assistance to an injured individual.*'}
              uw={true}
              name={'provideInfoFailure'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.provideInfoFailure ? driverContext?.driverHHM?.violationInfo?.provideInfoFailure : ""}
              setCallback={driverContext?.driverHHMCallback}
            />

            {/* Reckless driving */}
            <RadioButtonField
              question={'g. Reckless Driving, or a similar violation under the laws of any other state or municipality in or outside of Michigan.*'}
              uw={true}
              name={'recklessDriving'}
              infoKey='violationInfo'
              value={driverContext?.driverHHM?.violationInfo?.recklessDriving ? driverContext?.driverHHM?.violationInfo?.recklessDriving : ""}
              setCallback={driverContext?.driverHHMCallback}
            />
          </div>

          {/* Moving violations */}
          <RadioButtonField
            question={'Has driver received any moving violations, or accidents and/or Claims, regardless of fault, in the last 36 months?*'}
            uw={true}
            name={'movingViolations'}
            infoKey='violationInfo'
            value={driverContext?.driverHHM?.violationInfo?.movingViolations ? driverContext?.driverHHM?.violationInfo?.movingViolations : ""}
            setCallback={driverContext?.driverHHMCallback}
          />
        </div>
      )}
      </div>

      {/* New Jersey/Pennsylvania */}
      {context?.userData?.state !== 'Michigan' && (
        <div style={{ marginRight: '12px' }}>
          <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>
          {/* Mental/Physical Impairments */}
          <RadioButtonField
            question={"Does this driver have any mental or physical impairments, other than those listed above, that would impair their ability to operate a motor vehicle safely (Not including prescription eyeglasses or contact lenses)?*"}
            uw={true}
            name={'physicalImpairments'}
            infoKey='disabilityInfo'
            value={driverContext?.driverHHM?.disabilityInfo?.physicalImpairments ? driverContext?.driverHHM?.disabilityInfo?.physicalImpairments : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {/* Licensed under different name */}
          <RadioButtonField
            question={"Has this driver been licensed under a different name within the past 36 months?*"}
            uw={true}
            name={'diffNameLicensed'}
            infoKey='driverInfo'
            value={driverContext?.driverHHM?.driverInfo?.diffNameLicensed ? driverContext?.driverHHM?.driverInfo?.diffNameLicensed : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {/* Licensed under different state/country */}
          <RadioButtonField
            question={"Has this driver been licensed in another state or country within the past 36 months?*"}
            uw={true}
            name={'diffStateLicensed'}
            infoKey='driverInfo'
            value={driverContext?.driverHHM?.driverInfo?.diffStateLicensed ? driverContext?.driverHHM?.driverInfo?.diffStateLicensed : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {/* Moving violations */}
          <RadioButtonField
            question={"Has this driver received any Moving Violations and/or been in any Accidents or Claims in the last 36 moths, regardless of fault?*"}
            uw={true}
            name={'movingViolations'}
            infoKey='violationInfo'
            value={driverContext?.driverHHM?.violationInfo?.movingViolations ? driverContext?.driverHHM?.violationInfo?.movingViolations : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {/* Suspended */}
          <RadioButtonField
            question={"Has this driver’s license been suspended or in a suspended status in the last 36 months?*"}
            uw={true}
            name={'driverSuspended'}
            infoKey='violationInfo'
            value={driverContext?.driverHHM?.violationInfo?.driverSuspended ? driverContext?.driverHHM?.violationInfo?.driverSuspended : ""}
            setCallback={driverContext?.driverHHMCallback}
          />

          {/* Custody of a minor (New Jersey Only)*/}
          {context?.userData?.state == "New Jersey" &&
            <RadioButtonField
              question={"Does this applicant have custody of a minor?*"}
              uw={true}
              name={'minorCustody'}
              infoKey='userInfo'
              value={driverContext?.driverHHM?.userInfo?.minorCustody ? driverContext?.driverHHM?.userInfo?.minorCustody : ""}
              setCallback={driverContext?.driverHHMCallback}
            />
          }

          {!blIsMichigan && (
                <>
          <hr />

          {/* Helpful Documents (New Jersey & Pennsylvania Only) */}
          {context?.userData?.state == 'New Jersey' ? (
            <div className='text-center'>
              <HelpfulDocumentsNJ policyType={context?.userData?.policyType} />
            </div>
          ) : (
            <>
              <HelpfulDocumentsPA center='center' />
            </>
          )}
          </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AddDriverForm;
